const themeProperties = {
  defaultFontFamily:
    '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
  fontSizes: {
    fontXXSmall: '10px',
    fontXSmall: '12px',
    fontSmall: '14px',
    fontSixteen: '16px',
    fontMedium: '18px',
    fontLarge: '22px',
    fontXLarge: '26px',
    fontXXLarge: '36px',
    fontXXXLarge: '48px',
  },
  designSystem: {
    colors: {
      /** Planet Green */
      primaryColor: '#007A49',
      primaryColorTransparent7: '#007A4911',
      primaryColorTransparent10: '#007A491A',
      // Greens
      forestGreen: '#219653',
      leafGreen: '#27AE60',
      brightGreen: '#6FCF97',
      mintGradient: '#C9EFD9',
      softGreen: '#DDF4C4',
      // Yellows
      goldenYellow: '#F3B844',
      softYellow: '#FFF8E4',
      // Browns/Chocolates
      darkChocolate: '#2F211B',
      softDarkChocolate: '#EFE2DD',
      milkChocolate: '#6D4230',
      softMilkChocolate: '#FDF3EA',
      // Blues/Purples
      purpleSky: '#6C63FF',
      softSky: '#F3F2FF',
      oceanBlue: '#2F80ED',
      softBlue: '#EFFFFF',
      deepPurple: '#9B51E0',
      softPurple: '#F9F1FF',
      // Reds
      fireRed: '#EB5757',
      softRed: '#FFF3F3',
      // Text Colors
      coreText: '#333333',
      softText: '#4F4F4F',
      softText2: '#828282',
      hintText: '#BDBDBD',
      // Extended Palette
      warmGreen: '#68B030',
      sunriseOrange: '#F2994A',
      brightYellow: '#F2C94C',
      warmBlue: '#2D9CDB',
      skyBlue: '#56CCF2',
      baseGrey: '#F9F9F9',
      // Dark Colors
      deepBlue: '#082447',
      deepGreen: '#003333',
    },
  },
  primaryColor: '#68B030',
  primaryDarkColor: '#007a49',
  primaryDarkColorTransparent: '#007a491a',
  primaryLightColor: '#79AE4633',
  primaryLightGreenBgColor: '#F2F8F6',
  greenHazeColor: '#2196530d',
  lightBlueColor: '#48AADD',
  darkBlackColor: '#4F4F4F',
  darkOliveGreen: '#688816',
  topProjectBackgroundColor: '#F3BB44',
  topProjectTransparentColor: '#ffd273',
  lightOrange: '#e7b24c33',
  ceruleanBlueColor: '#2d9cdb0d',
  mintGreenColor: '#6fcf97',
  mediumGrayColor: '#828282',
  CharcoalGray: '#242424',
  mediumGrayColorTransparent: '#82828233',
  lightGrayColor: '#f2f2f2',
  amethystPurpleColor: '#9b51e00d',
  lavenderPurpleColor: '#c98eff',
  skyBlueColor: '#87ceeb',
  mediumBlueColor: '#2d9cdb',
  electricPurpleColor: '#9b51e0',
  nonDonatableProjectBackgroundColor: '#828282',
  deforestrationRangeBackgroundNew: '235, 87, 87',
  primaryColorNew: '#219653',
  primaryColorNewTransparent: '#21965333',
  horizontalLineColorNew: '#bdbdbd',
  restorationToggleColorNew: '#2f80ed',
  deforestrationToggleColorNew: 'rgba(235, 87, 87, 1)',
  exploreDescriptionBackground: '242, 242, 242',
  greenTwo: '#27ae60',
  light: {
    primaryFontColor: '#2f3336',
    dividerColor: '#d5d5d5',
    secondaryColor: '#ecb641',
    highlightBackground: '#4d5153',
    backgroundColor: '#fff',
    light: '#fff',
    richBlack: '#333333',
    dark: '#000',
    dangerColor: '#e74c3c',
    safeColor: '#2980b9',
    backgroundColorDark: '#F2F2F7',
    unDecadeFill: '#1d1d1b',
    mapboxIcon: 'invert(0) hue-rotate(180deg)',
    backgroundBase: '#F0F6F5',
    disabledFontColor: '#909090',
    tabBackgroundColor: '#f4ffec',
    grayFontColorNew: '#4F4F4F',
    lightGrayBackgroundColorNew: '#d9d9d9',
    boldFontColorNew: '#2F3336',
    selectedMenuItemColorNew: '#333',
    dividerColorNew: '#BDBDBD',
    reviewFontColorNew: '45, 156, 219', //used across elements with different opacities, this enables consistency throughout
    aboutProjectBackgroundColorNew: '#27ae601a',
    dangerColorNew: '#E86F56',
    abandonmentBackgroundColorNew: '242, 201, 76',
    moreInfoBackgroundColorNew: '81, 198, 205',
    certificationBackgroundColorNew: '108, 99, 255',
    contactDetailBackgroundColorNew: '232, 111, 86',
    certificationLinkColorNew: '#3AB6BD',
    secondaryDividerColor: '242, 153, 74',
    borderColor: '211, 211, 211',
  },
  dark: {
    primaryFontColor: '#ffffff',
    dividerColor: '#101113',
    secondaryColor: '#ecb641',
    backgroundColor: '#343a40',
    highlightBackground: '#f2f2f2',
    light: '#fff',
    dark: '#000',
    darkNew: '#333333',
    dangerColor: '#00ef00',
    safeColor: '#2980b9',
    backgroundColorDark: '#101113',
    unDecadeFill: '#fff',
    mapboxIcon: 'invert(0.8) hue-rotate(180deg)',
    backgroundBase: '#202020',
    disabledFontColor: '#686868',
  },
  fontWeight: '700',
};

export default themeProperties;
